angular.module('rjmNg.directives').directive "reportBuilderSelection", [
  () ->
    restrict: "E"
    templateUrl: "directive.reportBuilderSelection.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "app"
      "$scope"
      "$routeParams"
      "$clientAppUrl"
      (
        app
        $scope
        $routeParams
        $clientAppUrl
      ) ->

        view = @

        cohortSearchParams =
          cohortDefault: 1

        dashboardParams = ''

        if $routeParams.dashboardId?
          dashboardParams = "?dashboardId=#{$routeParams.dashboardId}"
          cohortSearchParams.dashboardId = $routeParams.dashboardId
          if $routeParams.row?
            row = parseInt($routeParams.row)
            dashboardParams += "&row=#{row}" if not isNaN(row)

        cohortParams = $.param(cohortSearchParams)

        view.cohortAnalysisPath = $clientAppUrl("/chartBuilder/create?#{cohortParams}")

        view.createSqlReportPath = $clientAppUrl("/reports/sql#{dashboardParams}")

        view.reportBuilderPath = $clientAppUrl("/reports/create#{dashboardParams}")

        view.canAccessSqlReportBuilder = () ->
          app.canAccessSqlReportBuilder()

        view.tempDisableFeatureForAUM = () ->
          app.tempDisableFeatureForAUM()

        view.canAccessCohortBuilder = () ->
          !app.hasFeatureFlag('RJQL_SERVICE_CLIENT')

        return view
    ]
]
